import { useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import dayjs from "dayjs";
import {
  useGetMVGraphDataQuery,
  useGetMVTableDataQuery,
} from "../MunicipalityDasboard/municipalityDataAPISlice";
import DarkDateRangePicker from "../OperatorDashboard/DarkDateRangePicker";
import MunicipalityGraph from "../MunicipalityDasboard/MunicipalityGraph";
import UtilityTable from "./UtilityTable";

export default function LandingPageUtility() {
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const [startDate, setStartDate] = useState(dayjs().subtract(1, "day"));
  const [endDate, setEndDate] = useState(dayjs());

  const request = {
    queryParams: {
      startDate: startDate.format("YYYY-MM-DD"),
      endDate: endDate.format("YYYY-MM-DD"),
      userTimezone: userTimezone,
    },
  };

  const {
    data: municipalityGraphData,
    isLoading: isLoadingMunicipalityGraphData,
    isSuccess: isSuccessMunicipalityGraphData,
    isError: isErrorMunicipalityGraphData,
    error: errorMessageMunicipalityGraphData,
  } = useGetMVGraphDataQuery(request);

  const {
    data: municipalityTableData,
    isLoading: isLoadingMunicipalityTableData,
    isSuccess: isSuccessMunicipalityTableData,
    isError: isErrorMunicipalityTableData,
    error: errorMessageMunicipalityTableData,
  } = useGetMVTableDataQuery(request);

  return (
    <Box sx={{ maxWidth: 1500, margin: "0 auto", padding: "80px 32px 48px", minHeight: "100vh", color: "#e0e6f0" }}>

      {/* Page header */}
      <Box sx={{ mb: "28px" }}>
        <Typography sx={{ fontSize: "1.7rem", fontWeight: 700, color: "#fff", letterSpacing: "-0.025em" }}>
          Demand M&amp;V
        </Typography>
        <Typography sx={{ fontSize: "0.88rem", color: "rgba(255,255,255,0.45)", mt: "4px" }}>
          Current Target Maximum Demand:{" "}
          <strong style={{ color: "#FDB940" }}>
            {municipalityGraphData?.target_demand !== undefined
              ? (municipalityGraphData.target_demand / 1000000).toFixed(3)
              : "—"} MVA
          </strong>
        </Typography>
      </Box>

      {/* Date picker */}
      <Box sx={{ mb: "24px" }}>
        <DarkDateRangePicker
          startDate={startDate}
          endDate={endDate}
          onApply={(start, end) => { setStartDate(start); setEndDate(end); }}
        />
      </Box>

      {/* Content card */}
      <Box
        sx={{
          backgroundColor: "#161B22",
          border: "1px solid rgba(255,255,255,0.06)",
          borderRadius: "12px",
          p: 2,
        }}
      >
        <Grid item xs={12} sx={{ mb: 2, mt: 1, ml: 1, mr: 1 }}>
          <MunicipalityGraph
            municipalityGraphData={municipalityGraphData}
            isSuccessMunicipalityGraphData={isSuccessMunicipalityGraphData}
            isErrorMunicipalityGraphData={isErrorMunicipalityGraphData}
            errorMessageMunicipalityGraphData={errorMessageMunicipalityGraphData}
            isLoadingMunicipalityGraphData={isLoadingMunicipalityGraphData}
            startDate={startDate}
            endDate={endDate}
          />
        </Grid>
        <Grid item xs={12} sx={{ mb: 2, ml: 1, mr: 1 }}>
          <UtilityTable
            municipalityTableData={municipalityTableData}
            isLoadingMunicipalityTableData={isLoadingMunicipalityTableData}
            isSuccessMunicipalityTableData={isSuccessMunicipalityTableData}
            isErrorMunicipalityTableData={isErrorMunicipalityTableData}
            errorMessageMunicipalityTableData={errorMessageMunicipalityTableData}
            startDate={startDate}
            endDate={endDate}
          />
        </Grid>
      </Box>
    </Box>
  );
}
